import '@babel/polyfill';
import Vue from "vue";
//import 'bootstrap-css-only/css/bootstrap.min.css'; 
//import 'mdbvue/build/css/mdb.css';
import App from "./App.vue";
//import posthogPlugin from "./plugins/posthog"; // import the plugin
//Vue.use(posthogPlugin); // install the plugin, before new Vue()

import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import {functionMixins} from './mixin/functionMixins';
Vue.mixin(functionMixins);
Vue.config.productionTip = false;
//import jQuery from 'jquery';
//global.jQuery=jQuery;
//global.$=jQuery;

import VueAnnouncer from '@vue-a11y/announcer';
Vue.use(VueAnnouncer , { }, router);

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import { MonthPickerInput } from "vue-month-picker";
Vue.use(MonthPickerInput);

new Vue({
  router,
  store,
  render: h => h(App) 
}).$mount("#app");
